export default __webpack_public_path__ + "static/media/Avatar1.076c667c.mp3";